import { Geometry, LineString, MultiPolygon, Point, Polygon } from "geojson";

export function pointToWkt(point: Point) {
  return `POINT (${point.coordinates[0]} ${point.coordinates[1]})`;
}

export function lineToWkt(line: LineString) {
  const locations = line.coordinates.map((location) => `${location[0]} ${location[1]}`);
  return `LINESTRING (${locations.join(", ")})`;
}

export function polygonToWkt(polygon: Polygon) {
  const coordinates = [...polygon.coordinates[0], polygon.coordinates[0][0]];
  const locations = coordinates.map((location) => `${location[0]} ${location[1]}`);

  return `POLYGON ((${locations.join(", ")}))`;
}

export function polygonToEwkt(polygon: Polygon) {
  const coordinates = [...polygon.coordinates[0], polygon.coordinates[0][0]];
  const locations = coordinates.map((location) => `${location[0]} ${location[1]}`);

  // polygon is in WGS84 (EPSG:4326)
  return `SRID=4326;POLYGON ((${locations.join(", ")}))`;
}

export function multiPolygonToWkt(geometry: MultiPolygon) {
  const wktCoordinates = geometry.coordinates.map((polygon) => {
    const wktPolygon = polygon.map((coordinates) => {
      const polygonPoints = coordinates.map((location) => `${location[0]} ${location[1]}`);
      return `(${polygonPoints.join(", ")})`;
    });

    return `(${wktPolygon.join(", ")})`;
  });

  return `MULTIPOLYGON (${wktCoordinates.join(", ")})`;
}

export function geometryToWkt(geometry: Geometry) {
  if (geometry.type === "Point") {
    return pointToWkt(geometry);
  }
  if (geometry.type === "LineString") {
    return lineToWkt(geometry);
  }
  if (geometry.type === "Polygon") {
    return polygonToWkt(geometry);
  }
  if (geometry.type === "MultiPolygon") {
    return multiPolygonToWkt(geometry);
  }
  throw new Error("Not implemented yet.");
}
